import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=ec38d1a2&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.scss?vue&type=style&index=0&id=ec38d1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec38d1a2",
  null
  
)

export default component.exports